import React from 'react';

const ValeursContainers = () => {
  const containerStyle = {
    display: 'flex', // Utilisation de Flexbox pour aligner les conteneurs horizontalement
    justifyContent: 'center', // Centrer les conteneurs horizontalement
    gap: '20px', // Espace entre les conteneurs
    padding: '20px',
    flexWrap: 'wrap', // Permet de passer à la ligne sur les petits écrans
  };

  const boxStyle = {
    backgroundColor: ' rgba(25, 33, 79, 0.9)',
    color: '#ffffff',
    padding: '20px',
    borderRadius: '8px',
    width: '300px', // Largeur uniforme pour chaque conteneur
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)', // Légère ombre pour effet visuel
    textAlign: 'center',
  };

  const titleStyle = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '10px',
  };

  const textStyle = {
    fontSize: '1rem',
    lineHeight: '1.6',
  };

  return (
    <div style={containerStyle}>
      {/* Conteneur Humain */}
      <div style={boxStyle}>
        <h2 style={titleStyle}>Humain</h2>
        <p style={textStyle}>
          - Collaborateur qualifié<br />
          - Formation continue personnalisée<br />
          - Évolution interne
        </p>
      </div>

      {/* Conteneur Sécurité */}
      <div style={boxStyle}>
        <h2 style={titleStyle}>Sécurité</h2>
        <p style={textStyle}>
          - Formation sécurité<br />
          - EPI de qualité et certifié<br />
          - Protocole strict
        </p>
      </div>

      {/* Conteneur Environnement */}
      <div style={boxStyle}>
        <h2 style={titleStyle}>Environnement</h2>
        <p style={textStyle}>
          - Matériaux écologiques<br />
          - Engins basse émission<br />
          - Évacuation dans des centres spécialisés
        </p>
      </div>
    </div>
  );
};

export default ValeursContainers;
